<template>
  <div>
      <div class="title">
        <h1>《青岛资本市场》期刊</h1>
        <div class="line"></div>
      </div>
<div style="width: 1800px;margin: 0 auto">



      <div class="imgs" v-for="( item, index) in journals" :key="index" @click="goto(item.link)">

        <img :src="item.picture" style="height: 100%;width: 100%">
        <p style="margin: 0 auto;padding-top: 15px"> {{ item.title }}</p>

      </div>

    <el-row>
      <el-col :span="4" :offset="11">
        <!--<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"-->
        <!--            @pagination="getJournalList"/>-->
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="12"
            layout="prev, pager, next"
            v-show="total>0" :total="total" >
        </el-pagination>
      </el-col>
    </el-row>
</div>
  </div>
</template>

<script>
import {
  getJournalList
} from "../api";

export default {
  name: 'journal',

  data() {
    return {
      journals: [],
      queryParams:{
        pageNum:1,
        pageSize:12,
      },
      total:0,
    }
  },
  mounted() { //页面加载完毕事件
    window.scroll(0, -0);

  },
  created() {
    this.getJournalList()
  }   ,
  methods: {
    getJournalList(){
      getJournalList(this.queryParams).then(res => {
        this.journals = res.data.rows
        this.total=res.data.total;
      })
    },

    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getJournalList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getJournalList()
    },

    goto(link) {
      window.open('http://' + link, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">

.imgs {

  height: 280px;
  width: 220px;
  display: inline-block;
  margin: 10px 30px 70px 30px;
  position: relative;
  left:60px;
  text-align: center;
  font-size: 18px;
  color: black;
  cursor: pointer;


}
.title{

  width: 1350px;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
  h1{
    font-size: 24px;
  }
  .line{
    border: 4px solid   rgba(90,89,89,0.24);

  }

}
::v-deep .el-pagination .el-select .el-input{
  display: none!important;
}
</style>
